import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AccountService, AlertService } from '../../_services';
import { MustMatch } from '../../_helpers';
import { DataService } from 'src/app/_services/data.service';
import { buyOrder, clientTrade } from 'src/app/_models/trade';
import { OrderService } from 'src/app/_services/order.service';
import { MatSnackBarComponent } from 'src/app/shared/components/mat-snack-bar/mat-snack-bar.component';
import { TradeService } from 'src/app/_services/trade.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { APP_DATE_FORMATS, AppDateAdapter } from 'src/app/shared/date.adapter';
import moment from 'moment';
import { BankService } from 'src/app/_services/bank.service';
import { OrbitService } from 'src/app/_services/orbit.service';
import { TamplateService } from 'src/app/_services/tamplate.service '; 
interface productType {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-add-new-order-bursa',
  templateUrl: './add-new-order-bursa.component.html',
  styleUrls: ['./add-new-order-bursa.component.less']
})
export class AddNewOrderBursaComponent {
  prodTypes: productType[] = [
    {value: 'DEPOSIT', viewValue: 'DEPOSIT'},
    {value: 'FINANCING', viewValue: 'FINANCING'},    
  ];
  commdityTypes: productType[] = [
    {value: 'AL-MSIA- 23', viewValue: 'Aluminium'},
    {value: 'CPO-MSIA-09', viewValue: 'Crude Palm Oil'},
    {value: 'PB-LEAD- 19', viewValue: 'PB Lead'},
    {value: 'PR-B-MSIA14', viewValue: 'Plastic Resin B'},
    {value: 'OLN-MSIA-12', viewValue: 'RBD Palm Olein'},
  ];

  OtherTenorUnit:productType[]=[
    {value: 'DAY', viewValue: 'DAY'},
  ];
  form: UntypedFormGroup;
  id: string;
  isAddMode: boolean;
  loading = false;
  submitted = false;
  newOrder:clientTrade;
  accounts: any[];
  orbit: any[];
  account = this.accountService.accountValue;
  isMurabahaConfirmed = false;
  isSaleConfirmed = false;
  showBuySell = false;
  orderInfo:buyOrder;
  isBank =false;
  isOrbit =false;
  banks :any[];
  brokerid :any[];
  enableResubmit = false;
  tamplates:any;
  constructor(
      private formBuilder: UntypedFormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private accountService: AccountService,
      private alertService: AlertService,
      private dataService:DataService,
      private orderService:OrderService,
      private snackBar: MatSnackBarComponent,
      private tradeService:TradeService,
      private bankService:BankService,
      private orbitService:OrbitService,
      private tamplateService:TamplateService,
  ) {}

  ngOnInit() {

    
    this.getAllBanks();
    this.dataService.getNewUserInfo().subscribe(info => {
      this.newOrder = info['tradeObj']; 
      this.brokerid = info['brokerid'];   
      this.isBank = info['type'] ==='BankTrade' ? true :false; 
    });
    this.dataService.getTradeObj().subscribe((tradeObj) =>{
      this.orderInfo = tradeObj['tradeObj'];
    });  
    this.accountService.getAll()
    .pipe(first())
    .subscribe(accounts => {
      this.accounts = accounts;
      this.fillForm();
    }
      );
      this.orbitService.getAllorbitclients().pipe(first())
      .subscribe(orbit => {
        this.orbit = orbit;
        this.fillForm();
      });

      this.id = this.route.snapshot.params['id'];
      this.isAddMode = !this.id;

      this.form = this.formBuilder.group({
        productType: ['', Validators.required],
        commodityType: ['', Validators.required],
        clientName: ['', Validators.required],
        clientName2: ['', Validators.required],
        orderDate: ['', Validators.required],
        valueDate: ['', Validators.required],
        currency: ['', Validators.required],
        nominalAmount: ['', Validators.required],
        saleAmount: ['', Validators.required],
        tenorOther:['',Validators.required],
        tenorOtherUnit:['',Validators.required],
        // templatename:['',Validators.required],
      });

      if (!this.isAddMode) {
          this.accountService.getById(this.id)
              .pipe(first())
              .subscribe(x => this.form.patchValue(x));
      }

     
  }
  getTemplatebycustomerid(cutomerid){
    this.tamplateService.getTemplatebycustomerid(cutomerid)
    .pipe(first())
    .subscribe(response => {
      this.tamplates = response;
    });
  }
  
  ngOnDestroy(): void {
    this.dataService.setSaleConfirm({
      isConfirmed: false
    });
    this.dataService.setMurabahaConfirm({
      isConfirmed: false
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  client1 = '';
  client2 = '';
  fillForm(){
    console.log('this.newOrder',this.newOrder);
    if(this.newOrder){
      this.getTemplatebycustomerid(this.newOrder.customerId)
      let clientName = '';
      let product = '';
      if(this.isBank){
        clientName = this.banks?.find((item) => item.id===this.newOrder.customerId).bankname;
        if(this.newOrder.product_type == 'DEPOSIT'||this.newOrder.product_type =='DEPOSITS'){
          product = 'DEPOSIT';
        }else{
          product = this.newOrder.product_type;
        }
      }
      else{
        product = this.newOrder.productType;
        if(this.newOrder.product_type == 'DEPOSIT - AGENT'||this.newOrder.productType == 'DEPOSIT - AGENT'){
          product = 'DEPOSIT';
        }else{
          product = 'FINANCING';
        }
        let clientName1 = this.accounts?.find((item) => item.id===this.newOrder.customerId);
        if(clientName1){
          clientName = clientName1.companyname;
        }else{
          this.isOrbit = true;
          clientName = this.orbit?.find((item) => item.id===this.newOrder.customerId)?.clientname||'';
        }
      }
      function singularize(value: string) {
        if (!value) return value;
      
        // remove trailing 's' or 'S' only
        if (value.endsWith("s") || value.endsWith("S")) {
          return value.slice(0, -1);
        }
        return value;
      }
      
      this.client2 = this.newOrder.clientName2||clientName;
      this.client1 = this.newOrder.customername||clientName;
 
      
      
      const formatted = singularize(this.newOrder.tenorOtherUnit||this.newOrder.tenorUnit);
      this.form.patchValue({
        nominalAmount: this.commify(Number(this.newOrder.costprice)),
        saleAmount: this.commify(Number(this.newOrder.differsaleprice)),
        currency:this.newOrder.currency,
        orderDate:new Date(this.newOrder.created),
        valueDate:new Date(this.convertDateToMMDDYYYY(this.newOrder.traderequestdate)),
        clientName2:this.client2,
        clientName:this.client1,
        productType:product,
        //orderTenor:this.newOrder.orderTenor,
        tenorOther:this.newOrder.tenorOther || this.newOrder.orderTenor,
        tenorOtherUnit:formatted,
      });
    } 
  } 
  convertDateToMMDDYYYY(datestring:string){
    let dateArray= datestring.split('/');
    return dateArray[1]+'/'+dateArray[0]+'/'+dateArray[2];
  }

  //function is used to convert date object to dd/MM/YYYY formate
  convertDate(inputFormat) {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/')
  }

  commify(n) {
    var parts = n.toString().split(".");

    const numberPart = parts[0];
    const decimalPart = parts[1];
    const thousands = /\B(?=(\d{3})+(?!\d))/g;

    return numberPart.replace(thousands, ",") + (decimalPart ? "." + decimalPart : "");
}
allowOnlyNumber(event: Event) {
  const input = event.target as HTMLInputElement;
  input.value = input.value.replace(/[^0-9]/g, '');
}
  onSubmit() {
   
      // stop here if form is invalid
      if (this.form.invalid) {
          return;
      }
     
    if(parseFloat(this.form.get('nominalAmount')?.value.replace(/,/g, '')) > 0){
        let clientName=''
        console.log('clientName', this.newOrder.customerId)
      if(this.isBank){
        clientName = this.banks?.find((item) => item.id===this.newOrder.customerId).bankname;
      }
      else{
        let clientName1 = this.accounts?.find((item) => item.id===this.newOrder.customerId);
        if(clientName1){
          clientName = clientName1.companyname;
        }else{
          clientName = this.orbit?.find((item) => item.id===this.newOrder.customerId).clientname;
        }
      }
      this.form.get('nominalAmount').patchValue( parseFloat(this.form.get('nominalAmount')?.value.replace(/,/g, '')).toString());
      this.form.get('saleAmount').patchValue( parseFloat(this.form.get('saleAmount')?.value.replace(/,/g, '')).toString());
      let payload = {
        customerId: this.newOrder.customerId,
        tradeID: this.newOrder.id,
        product_type: this.form.value.productType,
        commodity_type: this.form.value.commodityType,
        ownership: this.form.value.clientName,
        ownership2: this.form.value.clientName2,
        value_date: this.convertDate(this.form.get('valueDate').value),
        order_currency: this.newOrder.currency,
        order_amount:  this.form.get('nominalAmount').value,
        murabaha_amount: this.form.get('saleAmount').value,
        tenor: this.form.value.tenorOther,
        tenor_other_unit: this.form.value.tenorOtherUnit,
        registerby:this.account.id,
        brokerid:this.brokerid,
        templateid:this.newOrder.customerId,
    } 
    if(this.enableResubmit) {
      this.orderService.updateOrder(payload['tradeID'],payload).subscribe((res) =>{
        this.snackBar.openSnackBar('Order Re-submitted','Close','green-snackbar');
        this.submitted = true; 
      },(err) =>{
        this.snackBar.openSnackBar('something went wrong','Close','red-snackbar');
      })
    }
    else{
      this.orderService.registerOrder(payload).subscribe((res) =>{
        console.log('register order submitted');
        console.log(res);
        this.snackBar.openSnackBar(res['message'],'Close','green-snackbar');
        this.submitted = true; 
      },(err) =>{
        this.snackBar.openSnackBar('something went wrong'+err,'Close','red-snackbar');
      })
    }
  
    }
      else{
        this.snackBar.openSnackBar('Nominal Amount should be greater than 0','Close','red-snackbar');
      }
      
  }

  confirmOrder(){
    this.loading=true
    this.orderService.confirmOrderbursa(this.newOrder.id).subscribe((res) =>{    
      this.loading=false
      if(res['message']){
        this.snackBar.openSnackBar(res['message'],'Close','red-snackbar');
        this.submitted = false;
        this.enableResubmit = true;
      }
      else{
        this.snackBar.openSnackBar('Order confirmed','Close','green-snackbar');
        if(this.isBank){
          this.router.navigate(['/admin/bankTrades'], { relativeTo: this.route });
        }
        else{
          if(this.isOrbit){
            this.router.navigate(['/orbitadmin/tradeRequest'], { relativeTo: this.route });
          }else{
            this.router.navigate(['/admin/tradeRequest'], { relativeTo: this.route });
          }
          
        }
      }
    },(err) =>{
      console.log(err.message)
      this.snackBar.openSnackBar('something went wrong '+err.message,'Close','red-snackbar');
      this.loading=false
    })  
  }

  confirmCertificate2(){
    this.showBuySell = true;
  }

  rejectOrder(){
    this.tradeService.cancelTrade(this.newOrder.id,'rejected during trade initiate',
    'Trade has been declined','Trade has been declined by admin').subscribe((res) =>{
      this.snackBar.openSnackBar('Trade rejected','Close','red-snackbar');
      if(this.isBank){
        this.router.navigate(['/admin/bankTrades'], { relativeTo: this.route });
      }
      else{
        if(this.isOrbit){
          this.router.navigate(['/orbitadmin/tradeRequest'], { relativeTo: this.route });
        }else{
          this.router.navigate(['/admin/tradeRequest'], { relativeTo: this.route });
        }
      }
    })
  }

  cancelOrder(){
    this.submitted = false;
   // this.router.navigate(['/newOrder'], { relativeTo: this.route });
  }

  getAllBanks(){
    this.bankService.getAllBanks().subscribe((banks) =>{
      this.banks = banks;
    })
  }
}
